export type BenchlingNodeV2Status =
  | 'pending'
  | 'in-progress'
  | 'success'
  | 'warning'
  | 'error'
  | 'ai-proposed';

export const STATUS_COLORS: Record<BenchlingNodeV2Status | 'default', {color: string; colorIndex: number}> = {
  default: {color: 'gray', colorIndex: 6},
  error: {color: 'red', colorIndex: 8},
  'in-progress': {color: 'teal', colorIndex: 8},
  pending: {color: 'gray', colorIndex: 6},
  success: {color: 'green', colorIndex: 9},
  warning: {color: 'orange', colorIndex: 8},
  'ai-proposed': {color: 'purple', colorIndex: 8},
};

export const STATUS_BORDERS: Record<BenchlingNodeV2Status | 'default', 'dashed' | 'solid'> = {
  default: 'solid',
  error: 'solid',
  'in-progress': 'solid',
  pending: 'solid',
  success: 'solid',
  warning: 'solid',
  'ai-proposed': 'dashed',
};

export type SectionRowStatus = 'error' | 'warning';
export type EdgeStatus = 'error' | 'warning';
